import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Mca from '@/views/Mca'
import About from '@/views/About'
import Contact from '@/views/Contact'
import Terms from '@/views/Terms'
import PrivacyPolicy from '@/views/PrivacyPolicy'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/investor',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/mca-market',
      name: 'Mca',
      component: Mca
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/terms-conditions',
      name: 'Terms Conditions',
      component: Terms
    },
    {
      path: '/privacy-policy',
      name: 'Privacy Policy',
      component: PrivacyPolicy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js